import { ScheduleSelectorOverrideWrapper } from "slot-definitions"
import { Bound } from "lib/@components/binding/Bound"
import { registerTab, Tabs } from "lib/@components/tabs"
import { OriginalContent } from "routes/asset-register/plugins/regime-display/original-content"
import { isInRegime } from "routes/facilities/lib/when-parent-item"
import { Feature } from "lib/@components/feature"
import {
    FEATURE_FLAG_ADVANCED_REGIME_TABS,
    FEATURE_FLAG_ASSET_MAPPING,
} from "routes/asset-register/feature-flag-asset-mapping"
import { Box } from "@mui/material"
import { Lazy } from "lib/make-lazy"
import { registerFeature } from "lib/features"
import { FEATURE_FLAG_SCHEDULE_HISTORY } from "routes/asset-register/plugins/regime-display/feature_flag_regime_task_management"
import { FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/server/feature-flag-tailored-schedule-auditing.mjs"

registerFeature({
    numericalId: 1003,
    name: "Schedule History",
    id: FEATURE_FLAG_SCHEDULE_HISTORY,
    description: "Shows the difference between a regime and current SFG20",
})

ScheduleSelectorOverrideWrapper.plug(<AssetWrapper if={isInRegime} />)

export const REGIME_ASSETS_TAB = "regime_assets"

function AssetWrapper({ children }) {
    return (
        <Feature
            feature={[
                FEATURE_FLAG_ASSET_MAPPING,
                FEATURE_FLAG_ADVANCED_REGIME_TABS,
                FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING,
            ]}
            or
            fallback={children}
        >
            <Bound normalChildren={children}>
                <Tabs searchParam id={REGIME_ASSETS_TAB} panelHolder={<Box mt={1} />} />
            </Bound>
        </Feature>
    )
}

registerTab({
    tab: REGIME_ASSETS_TAB,
    id: "original",
    title: "Schedules",
    content: <OriginalContent $lazy priority={10} />,
})

registerTab({
    tab: REGIME_ASSETS_TAB,
    id: "assets",
    title: "Assets",
    // Hidden for share-link visitors: the asset register is not part of the shared view
    predicate: (context) => !context?.isShare,
    content: (
        <Lazy
            priority={110}
            importer={() => import("routes/asset-register/plugins/regime-display/asset-view")}
            extract="AssetView"
        />
    ),
})

// WIN-1706 make tasks tab unavailable to configure but available for devs.
// registerTab({
//     tab: REGIME_ASSETS_TAB,
//     id: "asset-tasks",
//     title: "Tasks",
//     predicate: () => isEnabled(FEATURE_FLAG_ASSET_MAPPING_TASK_MANAGEMENT),
//     content: (
//         <Lazy
//             priority={120}
//             importer={() => import("routes/asset-register/plugins/regime-display/asset-task-view")}
//             extract="AssetTaskView"
//         />
//     ),
// })
